import { generateTheme } from '@cld/theme-helper';
import { lightTheme } from '@clds/themes';
import { State } from '../state';

export const selectGeneratedTheme = (state: State) => {
  if (state.applicationStatus === 'ready') {
    return state.theme.styledComponentsThemeObject;
  }

  // FIXME: adjust in the future to show dark theme before any data is loaded
  return generateTheme(lightTheme);
};
